var map = {
	"./banner-logo-2.png": 1889,
	"./banner-logo-22.png": 4775,
	"./banner-logo-3.png": 8024,
	"./banner-logo-4.png": 7639,
	"./banner-logo-5.png": 5150,
	"./banner-logo-6.png": 901,
	"./banner-logo-7.png": 4988,
	"./banner-logo-8.png": 4875,
	"./banner-logo.png": 8948,
	"./footer-logo-2.png": 7656,
	"./footer-logo.png": 4793,
	"./icon-blog.png": 722,
	"./icon-cafe.png": 537,
	"./icon-channel.png": 3661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;